<script setup lang="ts">
import SiteChanger from '@/components/SiteChanger.vue'
import { useSiteStore } from '@/stores/site'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const siteStore = useSiteStore()
</script>

<template>
  <div class="layout-footer">
    <div v-if="isDevelopment" class="site-choice">
      <SiteChanger />
    </div>

    <div>
      {{ t('copyright') }} by
      <a :href="siteStore.organizerInfo.homepage" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">
        {{ siteStore.organizerInfo.companyName }}
      </a>
    </div>
  </div>
</template>

<style lang="css">
.layout-footer {
  position: relative;
}

.demo-area {
  position: absolute;
  right: 0;
  width: 250px;
}

.site-choice {
  position: absolute;
  left: 0;
  width: 250px;
}
</style>

<!-- prettier-ignore -->
<i18n lang="yaml">
ko:
  copyright: '참가기업 등록 시스템'
en:
  copyright: 'Exhibitor Management System'
</i18n>
